/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Pipe, PipeTransform } from '@angular/core';
import { ModelProperty } from '../engine/model-property';
import { Mask } from '../enum/mask.enum';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'mask',
  standalone: true,
})
export class MaskPipe implements PipeTransform {
  static applyMask(value: string, property: ModelProperty) {
    switch (property.mask) {
      case Mask.temperature:
        return `${value}°C`;
      case Mask.tva:
        return `${value}%`;
      case Mask.currency:
        return new CurrencyPipe('fr').transform(value, property.currency);
      case Mask.amount:
        return this.transformAmount(value);
      default:
        return value;
    }
  }

  /**
   * transform 1000 => 1 000
   * @param value
   */
  static transformAmount(value: string) {
    let valueNum: number;
    if (typeof value === 'string') {
      valueNum = parseFloat(value);
    } else {
      valueNum = value;
    }
    if (!isNaN(valueNum)) {
      if (valueNum % 1 === 0 || valueNum === 0) {
        const length = (valueNum + '').length;
        if (length > 3) {
          return (valueNum + '').replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        } else {
          return value;
        }
      } else {
        const integers = (valueNum + '').split('.')[0];
        const decimals = (valueNum + '').split('.')[1];
        const length = (integers + '').length;
        if (length > 3) {
          const withSpace = integers.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
          return `${withSpace}.${decimals}`;
        } else {
          return `${integers}.${decimals}`;
        }
      }
    } else {
      return '-';
    }
  }

  transform(value: any, property: ModelProperty): any {
    return MaskPipe.applyMask(value, property);
  }
}
